export const VALUATION_BASE_COLUMNS = [
  {
    id: 'obito',
    header: 'Data do óbito (ITCMD Causa Mortis · RI · espólio)',
  },
  {
    id: 'escritura',
    header: 'Atualizado, escritura (ITCMD Doação · emolumentos)',
  },
  {
    id: 'partilha',
    header: 'Declarado escritura, IR (quinhões · partilha amigável)',
  },
] as const;
